<template lang="pug">
    include /@ibkr/lib.common/src/icon/arrow
    ib-col(class="flex")
        //p(class="insety-16", v-if="search.length > 0") {{ $t('showing') }} {{ search.length }} {{ $t('of') }} {{ search.length }}
        //p(class="insety-16", v-else) {{ $t('showing') }} {{ mainContracts.length }} {{ $t('of') }} {{ mainContracts.length }}
        SearchTerm(:contracts="mainContracts", @clearRes="clearSearch", @searchRes="setSearch")
        div(v-if="view")
            WSTable(:position="position", :view="view", @hideTable="hideView", ref="wstable")
        ib-table-basic(
            class="quotes",
            :data="search.length > 0 ? search : mainContracts",
            root="window",
            root-margin="156px",
            rowstripe,
            rowborder,
            colborder,
            @enter="rowEnter"
        )
            ib-table-col(
                width="12ch",
                sticky
            ) {{ $t('ib_symbol') }}    
            ib-table-col(
                width="36ch",
            ) {{ $t('product_description') }} ({{ $t('more_details') }})
            ib-table-col(
                width="12ch"
            ) {{ $t('currency') }}    
            template(v-slot:body="pos")
                td(:title="pos.ticker")
                    span(
                        v-text="pos.ticker",
                        class="end-8 text-bold"
                    )
                td(@click="viewTable(pos)", :title="pos.desc")
                    span(class="red", v-text="pos.desc")
                td(:title="pos.currency")
                    span(
                        v-text="pos.currency",
                        class="end-8 text-bold"
                    )
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import realtime from '@ibkr/clientportal.common/src/js/realtime'
    import * as cmnTypes from '@ibkr/clientportal.common/src/store/mutation-types'

    import SearchTerm from './SearchTerm.vue'
    import WSTable from './WSTable.vue'
    import api from '@ibkr/clientportal.common/src/api/index.js'
    import ap from '../ap/'
    const DEFAULT_EXCHANGE = 'EUIBSI';

    const MD_FIELDS = [ '88', '84', '85', '86', '31']; // Add '31' for debugging

    export default {
        name: 'SiQuotes',
        
        components: {
            SearchTerm,
            WSTable
        },

        data() {
            return {
                mainContracts: [],
                search: [],
                loading: true,
                error: undefined,
                view: false,
                position: null,
                subscribed: undefined,
                queuedTimeout: undefined,
            }
        },
        
        created() {
            this.getConids();
        },

        computed: {
            ...mapGetters({
                md: 'iserverData/marketData'
            }),

            ...mapGetters('options', ['realtime'])
        },

        methods: {
            ...mapMutations('options', {
                'setRealtime': cmnTypes.SET_ENABLE_REALTIME
            }),

            getConids() {
                this.loading = true;
                this.error = undefined;
                api.getConidsByExchange(this.getExchange())
                    .then(res => {
                        this.initWs();
                        this.mainContracts = res;
                    })
                    .catch(err => {
                        this.error = err;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            getDescription(ids) {
                console.log("description ids", ids)
                const minId = ids[0];
                const conids = ids.map(id => this.mainContracts[id]['conid']).join(',');
                console.log("conids", conids)
                ap.getDescription(conids)
                    .then(res => {
                        res.secdef.forEach((item, index) => {
                            const foundContract = this.mainContracts.find(contract => contract.conid === item.conid);
                            console.log("foundCountract", foundContract)
                            const foundIndex = this.mainContracts.findIndex(contract => contract.conid === item.conid);
                            console.log("foundIndex", foundIndex)
                            if (item.conid === foundContract.conid) {
                                Vue.set(this.mainContracts[foundIndex], 'desc', item['name'])
                                Vue.set(this.mainContracts[foundIndex], 'currency', item['currency'])
                            }
                        });
                    })
                    .catch(error => console.error(error))
            },

            getExchange() {
                const urlParams = new URLSearchParams(window.location.search);
                const siExchange = urlParams.get('siExchange');
                return siExchange || DEFAULT_EXCHANGE;
            },

            hideView() {
                this.view = false;
            },

            rowEnter(id) {
                if (!this.mainContracts[id].searched) {
                    const min = Math.min(id + 25, this.mainContracts.length - 1);
                    const nextids = [];
                    for (let i = id; i <= min; i++) {
                      nextids.push(i);
                      this.mainContracts[i].searched = true;
                    }
                    this.getDescription(nextids);
                }
            },

            viewTable(pos) {
                this.position = [];
                this.position.push(pos);
                this.view = true;
                // Check to make sure websocket is connected.
                this.queuedTimeout = clearTimeout(this.queuedTimeout);
                if (!window.ibrt || !window.ibrt.connected) {
                    this.queuedTimeout = setTimeout(() => {
                        this.viewTable(pos);
                    }, 4000)
                    return;
                }

                if (this.subscribed === pos.conid) {
                    return;
                } else {
                    this.unsubscribe(); // Unsub from previous subscription
                    this.subscribed = pos.conid;
                    this.$store.dispatch('iserverData/getMarketdata', {
                        conids: [this.subscribed + '@' + DEFAULT_EXCHANGE],
                        fields: MD_FIELDS
                    });
                }
            },

            unsubscribe() {
                if (window.ibrt && window.ibrt.connected && this.subscribed) {
                    // this.$store.dispatch('iserverData/unsubscribeMarketData', { conid: this.subscribed });
                    window.ibrt.ws.send('umd+' + this.subscribed + '@' + DEFAULT_EXCHANGE); // Used because above action doesn't work.
                }
            },

            clearSearch() {
                this.search = [];
                this.view = false;
                this.unsubscribe();
            },

            setSearch(search) {
                this.search = search;
                ap.getDescription(this.search[0]['conid'])
                    .then(res => {
                        Vue.set(this.search[0], 'desc', res['secdef'][0]['name'] )
                        Vue.set(this.search[0], 'currency', res['secdef'][0]['currency'] )
                    })
            },

            initWs() {
                if (!window.ibrt) {
                    console.debug('Initialising websocket');
                    if (!('WebSocket' in window)) {
                        console.debug('Browser doesnt support websockets.');
                        this.setRealtime(false);
                        return;
                    }
                    window.ibrt = realtime.instance();
                    if (window.ibrt) {
                        // window.ibrt.toggleConsoleLog(); // Use to debug all socket message data
                        window.ibrt.addEventListener((e) => {
                            console.debug('realtime socket event', e.event, e);
                            switch(e.event) {
                                case 'open':
                                    console.debug('Websocket Initialised');
                                    this.setRealtime(true);
                                    break;
                                case 'close':
                                    console.debug('Websocket Closed');
                                    this.setRealtime(false);
                                    break;
                            }
                        });
                    }
                }
            }
        },

        watch: {
            search: {
                handler: function() {
                    if (this.search.length > 0) {
                        this.view = false;
                        this.unsubscribe();
                    }
                }
            }
        }
    }
</script>

<style lang="less">
    .quotes {
        table {
            border-top: 1px solid rgba(0,0,0,0.1);
            border-left: 1px solid rgba(0,0,0,0.1);
            border-bottom: 1px solid rgba(0,0,0,0.1);
        }
        th {
            background-color: #dcdcde;
            border-right: 1px solid rgba(0,0,0,0.1);
            color: #000;
            font-weight: bold;
            svg {
                color: #000;
            }
            > span {
                width: 100%;
            }
        }
        .red {
            color: #db1222;
        }
    }
</style>